// BaB Toggles
window.selections = {};

const getTotals = () => {
  setTimeout(() => {
    const bundleProductCards = document.querySelectorAll(
      ".bundle-product-card"
    );
    let totalQuantity = 0;

    bundleProductCards.forEach((card) => {
      const quantity = parseInt(card.getAttribute("quantity"));
      if (!isNaN(quantity)) {
        if (quantity) {
          window.selections[card.getAttribute("pid")] = {
            quantity,
            img: card.querySelectorAll("img")[1].src,
          };
        } else {
          window.selections[card.getAttribute("pid")] = { quantity: 0 };
        }
        totalQuantity += quantity;
      }
    });
  }, 10);
};
// Only run this script if the URL includes the specified path
if (
  window.location.href.includes(
    "/tools/bundle-subscriptions/bundle/8398728298647"
  ) ||
  window.location.href.includes(
    "/tools/bundle-subscriptions/bundle/8450585460887"
  )
) {
  // Function to scroll to section
  function addListeners() {
    const button = document.querySelector(
      ".bundle-product-card__quantity-button-container--button"
    );

    // if we find one button we assume they're all loaded
    if (button) {
      // Create a listener for all elements with selector '.bundle-product-card__quantity-button-container--button'
      const elements = document.querySelectorAll(
        ".bundle-product-card__quantity-button-container--button"
      );
      elements.forEach((element) => {
        element.addEventListener("click", function (e) {
          getTotals();
        });
      });

      setTimeout(function () {
        getTotals();
      }, 500);

      return true; // Indicates that we attempted to scroll
    }

    return false; // Indicates that we did not attempt to scroll
  }

  // Interval to continually check for the card elements
  const intervalId = setInterval(() => {
    if (addListeners()) {
      clearInterval(intervalId); // Stop checking once updates are made
    }
  }, 50); // Check every 100 milliseconds

  // add custom sizes toggle
  const addToggle = () => {
    const isScreenGreaterThan750px = window.innerWidth > 750;
    const headerContainer = document.querySelector(
      isScreenGreaterThan750px
        ? ".awtomatic-bab-options-container"
        : ".bundleapp-modal__container--complete-screen--header-container"
    );

    if (headerContainer) {
      headerContainer.innerHTML =
        `
         <div class="awt-bab-header">
            <div class="awt-bab-header__logo"></div>
            <h1 class="awt-bab-header__title">Build Your Skincare Ritual</h1>
            <h4 class="awt-bab-header__subtitle">Get 10% off and free shipping on
your bundle of 3+ products</h4>
         </div>
          <!--<span modifiers="subheading" id="choose_plans" class="bundle-text--subheading">Choose your plan</span>
          <div id="awt-custom-size-butons" class="" role="radiogroup" aria-label="Select a size">
            <label id="41085917462564" classes="awtomic-sizes-2-3-products"
                for="gid://shopify/ProductVariant/41085917462564-size-selector"
                class="sc-eLgOxx jQNpuT awtomic-sizes-2-3-products bundle-button">
                <span class="awtomic-sizes-label-2-3-products">2-3 products</span>
                <input type="radio" id="gid://shopify/ProductVariant/41085917462564-size-selector" name="size" role="radio"
                    aria-checked="true" tabindex="0" value="gid://shopify/ProductVariant/41085917462564" checked="">
            </label>
            <label id="41085922836516" classes="awtomic-sizes-4-or-more-products"
                for="gid://shopify/ProductVariant/41085922836516-size-selector"
                class="sc-eLgOxx jQNpuT awtomic-sizes-4-or-more-products bundle-button">
                <span class="awtomic-sizes-label-4-or-more-products">3+ Products</span>
                <input type="radio" id="gid://shopify/ProductVariant/41085922836516-size-selector" name="size" role="radio"
                    aria-checked="true" tabindex="0" value="gid://shopify/ProductVariant/41085922836516" checked="">
            </label>
        </div>-->
        <span modifiers="subheading" id="delivery_options" class="">Delivery Frequency</span>
        <h4 class="awt-bab-header__subtitle">Save an <b>additional 15% off</b> every shipment when you choose auto-renew</h4>
        ` + headerContainer.innerHTML;

      // current select 1-5
      if (
        window.location.href.includes(
          "/tools/bundle-subscriptions/bundle/8398728298647"
        )
      ) {
        // document.getElementById("41085917462564").classList.add("selected");
        // document
        //   .getElementById("41085922836516")
        //   .addEventListener("click", function () {
        //     const urlParams = new URLSearchParams(window.location.search);
        //     const sellingPlanValue = urlParams.get("selling_plan") || "onetime";
        //     window.location.href = `/tools/bundle-subscriptions/bundle/8450585460887?product=build-your-ritual-4&selling_plan=${sellingPlanValue}&${Object.keys(
        //       window.selections
        //     )
        //       .map((key) => `${key}=${window.selections[key].quantity}`)
        //       .join("&")}`;
        //   });
      }
      // current selection 6+
      else if (
        window.location.href.includes(
          "/tools/bundle-subscriptions/bundle/8450585460887"
        )
      ) {
        // document.getElementById("41085922836516").classList.add("selected");
        // document
        //   .getElementById("41085917462564")
        //   .addEventListener("click", function () {
        //     const urlParams = new URLSearchParams(window.location.search);
        //     const sellingPlanValue = urlParams.get("selling_plan") || "onetime";
        //     window.location.href = `/tools/bundle-subscriptions/bundle/8398728298647?product=build-your-ritual&selling_plan=${sellingPlanValue}`;
        //   });
      }

      return true;
    }

    return false;
  };
  // Interval to continually check for the header
  const intervalId2 = setInterval(() => {
    if (addToggle()) {
      clearInterval(intervalId2); // Stop checking once updates are made
    }
  }, 50); // Check every 100 milliseconds
}
// End BaB Toggles

// FIX BAB SECTION NAV
document.addEventListener("DOMContentLoaded", function () {
  // Function to escape invalid CSS selectors
  function escapeCSSId(id) {
    return id.replace(/([!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~])/g, "\\$1");
  }

  // Function to add click listeners to the nav buttons
  function addNavButtonListeners() {
    const buttons = document.querySelectorAll("nav.bundle-section__nav button");
    buttons.forEach((button) => {
      button.addEventListener("click", function () {
        const sectionId = button.id.replace("button-", "");
        const escapedId = escapeCSSId(sectionId);
        const section = document.getElementById(`${sectionId}`);
        const yOffset = -50; // Amount to offset the scroll position
        const y =
          section.getBoundingClientRect().top + window.pageYOffset + yOffset;
        if (section) {
          section.scrollIntoView({ block: "center", behavior: "smooth" });
        }
      });
    });
  }

  // Function to check if we are on the correct URL path
  function checkUrlAndSetup() {
    if (
      window.location.pathname.includes("/tools/bundle-subscriptions/bundle")
    ) {
      const checkNavButtons = setInterval(function () {
        const navButtons = document.querySelectorAll(
          "nav.bundle-section__nav button"
        );
        if (navButtons.length > 0) {
          clearInterval(checkNavButtons);
          addNavButtonListeners();
        }
      }, 100); // Check every 100ms
    }
  }

  // Run the check and setup function
  checkUrlAndSetup();
});
// END FIX BAB SECTION NAV

// CART REMOVE JS
// Registers each cart bundle item's remove button
document.querySelectorAll("a.cart__remove-bundle").forEach((button) => {
  button.addEventListener("click", async (event) => {
    if (!event.target.matches("a.cart__remove-bundle, a.cart__remove-bundle *"))
      return;
    const bundle_id = button.getAttribute("data-bundle-id");

    try {
      // Get current cart contents
      const cart = await (await fetch("/cart.js")).json();

      // Create data object for cart update AJAX call
      const data = {
        updates: cart.items.reduce(
          (acc, item) =>
            item.properties?._bundleUid == bundle_id
              ? { ...acc, [item.key]: 0 }
              : acc,
          {}
        ),
      };

      // API call to update the cart contents and set the bundle item quantities to 0
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      response.ok && (window.location.href = "/cart");
    } catch (error) {
      console.error(error);
    }
  });
});
// END CART REMOVE JS
